<template> 
    <div class="controls">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
        </head>  
        <button class="button" v-if="!deviceCharacteristic"
                :class="{'is-warning': !deviceCharacteristic, 'is-success' : deviceCharacteristic }" 
                :disabled="deviceCharacteristic"
                id="pair" v-on:click="connect">Connect device</button>
        <div v-if="deviceCharacteristic">

            <div class="control">
                <label class="label">Transistor is {{mode==='Current' ? 'On' : 'Off'}}</label>               
                <button class="button is-info"                                
                    :disabled="mode==='Voltage'"                
                    v-on:click="switchMode('Voltage')">Off</button>   
                <button class="button is-danger"                                
                    :disabled="mode==='Current'"                
                    v-on:click="switchMode('Current')">On</button> 
            </div>      

            <div class="control">
                <label class="label">Switch current meter</label>               
                <button class="button is-info"    
                    :disabled="useIsmall===false"                                                  
                    v-on:click="switchCurrentToBig()">Big (18A)</button>   
                <button class="button is-warning"  
                    :disabled="useIsmall===true"                                                    
                    v-on:click="switchCurrentToSmall()">small (0.9A)</button> 
            </div>        

            <div class="control">
                <label class="label">Mppt</label>               
                <button class="button is-danger"  
                    :disabled="mpptOn===true"                                                   
                    v-on:click="switchMpptOn()">On</button>   
                <button class="button is-info" 
                    :disabled="mpptOn===false"                                                    
                    v-on:click="switchMpptOff()">Off</button> 
            </div>   

            <div class="filed">
                <label class="label">Power, Wt</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="power"
                        :disabled="true" 
                        placeholder="power">
                </div>
            </div>     

            <div class="filed">
                <label class="label">Voltage, V</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="voltage"
                        :disabled="true" 
                        placeholder="voltage">
                </div>
            </div>

           <div class="filed">
                <label class="label">Current, A</label>
                <div class="control">
                     <input class="input" type="input"
                        :class="{'is-danger' : overheat, 'is-warning' : heatsinkTemperature > 45}"
                        v-model="current"
                        :disabled="true" 
                        placeholder="current">  
                </div>
            </div>   

            <button class="button is-info"                                
                :disabled="(sendLocked || isMultimetrOn)"                
                v-on:click="startMeasuring">Start measuring</button>        

            <button class="button is-danger"                                 
                :disabled="(sendLocked || !isMultimetrOn)"
                v-on:click="stopMeasuring">Stop measuring</button>
            
            <div class="label">
                Sensors:
            </div>

            <div class="filed">
                <label class="label">Panel temperature, C</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="avarageTemperature"
                        :disabled="true" 
                        placeholder="temperature">  
                </div>
            </div>

            <div class="filed">
                <label class="label">Average light, W/m2</label>
                <div class="control">
                     <input class="input" type="input"
                        v-model="avarageLight"
                        :disabled="true" 
                        placeholder="light">
                </div>
            </div>

           <div class="filed">
                <label class="label">Tester temperature, C</label>
                <div class="control">
                     <input class="input" type="input"
                        :class="{'is-danger' : overheat, 'is-warning' : heatsinkTemperature > 45}"
                        v-model="heatsinkTemperature"
                        :disabled="true" 
                        placeholder="tester temperature">  
                </div>
            </div>   

            <div v-if="error" class="notification  is-warning">{{error}}</div>

            <figure class="image is-128x128" v-if="deviceCharacteristic && sendLocked">
                <img src="..\assets\spinner.gif">
            </figure>
        </div>
    </div>
</template>
<script>
import { 
    startMultimetrCommand, 
    stopMultimetrCommand, 
    switchTransitorOnCommand, 
    switchTransitorOffCommand,
    CommandUseSmallCurrent,
    CommandUseBigCurrent,
    CommandMpptOn,
    CommandMpptOff } from '../shared/config';
import { parser } from '../shared/parser';
export default {
    name: "Multimetr",
    async created () {
        if(!this.$store.state.accessToken){
            this.$router.push('login');
            return;            
        }
    },
    data() {
        return {
            
            //sampleTemperature: undefined,
            serviceUUID : "0000ffe0-0000-1000-8000-00805f9b34fb",
            characteristicId : "0000ffe1-0000-1000-8000-00805f9b34fb",
            deviceCharacteristic : null,
            endChar : '&',   
            message: '',  
            locked: false,
            
            current: undefined,
            voltage: undefined,       
            power: undefined,     

            overheat : false,
            tHeatsinkMax : 50,           

            mode: 'Voltage',
            error: undefined,

            mpptOn: false,
            useIsmall: false,

            isMultimetrOn: false,

            avarageTemperature: undefined,
            avarageLight: undefined,
            heatsinkTemperature: undefined,

            avaragingItmesCount : 3,

            currentArray : [],
            voltageArray: [],
        }
    },
    mounted () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            // const button = document.getElementById('pair');
            // button.addEventListener('pointerup', function () {
                // this.connect();
            // });
        })
    },
    computed: {
        sendLocked() {
            return this.locked || !this.deviceCharacteristic;
        },
    },   
    methods: {        
        async onNewMessage(msg) {
            if (!msg)
                return;
            const index = msg.indexOf(this.endChar);
            if (index >= 0) {
                let newMsg = msg.substring(0, index);
                this.message += newMsg;
                if (index === msg.length - 1) {
                    msg = "";
                }
                else {
                    msg = msg.substring(index + 1, msg.length);
                }
                // TODO: handle message
                console.log(this.message);
                const sensorMessageStart = "Sns;";  
                const multimetrResult = "Met;";  
                const commandError = "er:";  
                const commandEnd = "end"; 
                const switchTransistorResponse = "Tr=";
                              
                
                if(parser.stringContains(this.message,sensorMessageStart))
                {
                    if(parser.stringContains(this.message,"Vx"))
                    {
                        this.isMultimetrOn = true;
                    }

                    if(parser.stringContains(this.message,"Tr=1"))
                    {
                        this.mode = "Current";                        
                    }
                    else
                    {
                        this.mode = "Voltage"; 
                    }

                    if(parser.stringContains(this.message,"Mppt=1"))
                    {
                        this.mpptOn = true;
                    }
                    else
                    {
                        this.mpptOn = false;
                    }

                    if(parser.stringContains(this.message,"Ismall=1"))
                    {
                        this.useIsmall = true;
                    }
                    else
                    {
                        this.useIsmall = false;
                    }

                    const sensors = parser.readSensorsMessage(this.message);  
                    
                    this.addArrayValue(this.currentArray, sensors.current);
                    this.addArrayValue(this.voltageArray, sensors.voltage);
                    
                    this.current = this.getAverageAtArray(this.currentArray);
                    this.voltage = this.getAverageAtArray(this.voltageArray);

                    this.power = (this.current && this.voltage) ? Math.round(this.current * this.voltage * 1000) /1000 : null;

                    /* eslint-disable no-debugger */
                    //debugger;
                    /* eslint-enable no-debugger */

                    this.avarageLight = sensors.light;
                    this.avarageTemperature = sensors.tModule;
                    this.heatsinkTemperature = sensors.tHeatsink;  
                    this.overheat =  sensors.tHeatsink > this.tHeatsinkMax;                       
                }
                else if(parser.stringContains(this.message,multimetrResult))
                {
                    const multimetrState = parser.readState("On=",this.message);
                    this.isMultimetrOn = multimetrState.isOn == 1;

                    this.error = undefined;
                    this.locked = false;
                }
                else if(parser.stringContains(this.message,commandEnd))
                {
                    this.error = undefined;
                    this.locked = false;
                }
                else if(parser.stringContains(this.message,commandError))
                {

                    this.error = this.message;
                    this.locked = false;
                }
                else if(parser.stringContains(this.message, switchTransistorResponse))
                {
                    const transistorState = parser.readState("Tr=",this.message);  
                    console.log("Transistor state = " + transistorState.isOn);                  
                    this.error = undefined;
                    this.locked = false;
                }

                
                this.message = "";
                if (msg) {
                    await this.onNewMessage(msg);
                }
            }
            else {
                this.message += msg;
            }

        },
        
        async handleCharacteristicValueChanged(event) {
            const value = event.target.value;
            const length = value.byteLength;
            if (length <= 0)
                return;
            let msg = String.fromCharCode([value.getUint8(0)]);

            for (var i = 1; i < length; i++) {
                msg += String.fromCharCode([value.getUint8(i)]);
            }
            await this.onNewMessage(msg);
            //console.log('Received ' + msg);
        },

        onTesterDisconnected(){
            console.log("on tester disconected");
            this.$data.deviceCharacteristic = null;            
        },

        async connect(){
            document.addEventListener('onTesterDisconnected',this.onTesterDisconnected);

            navigator.bluetooth.requestDevice({
                acceptAllDevices: true,
                optionalServices: [this.serviceUUID]
            })
            .then(device => {
                // Human-readable name of the device.
                console.log(device.name);
                device.ongattserverdisconnected = function () {                                        
                    console.log("Tester disconnected");
                    document.dispatchEvent(new CustomEvent('onTesterDisconnected', {}));
                };
                // Attempts to connect to remote GATT Server.
                return device.gatt.connect();
            })
            .then(server => {
                //console.log(server);
                return server.getPrimaryService(this.serviceUUID);
            })
            .then(service => {
                console.log(service);
                //return service.getCharacteristic
                return service.getCharacteristic(this.characteristicId);
            })
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
                characteristic.addEventListener('characteristicvaluechanged',
                    this.handleCharacteristicValueChanged);
                console.log('Notifications have been started.');
                this.deviceCharacteristic = characteristic;
            })
            .catch(error => {
                console.log(error);
                this.deviceCharacteristic = null;
            });
        },

        sendCommand(command){
             if (this.deviceCharacteristic == null) {
                console.log('writer is null');
            }
            else {
                this.locked = true;
                console.log('send command ' + command );
                var value = Uint8Array.of(command);
                this.deviceCharacteristic.writeValue(value);                                
            }
        },

        switchMode(newMode){
            if(newMode == "Current")
            {
                this.sendCommand(switchTransitorOnCommand);
            }
            else
            {
                this.sendCommand(switchTransitorOffCommand);
            }
        },

        switchCurrentToBig(){
            this.sendCommand(CommandUseBigCurrent);
        },

        switchCurrentToSmall(){
            this.sendCommand(CommandUseSmallCurrent);
        },

        switchMpptOn(){
            this.sendCommand(CommandMpptOn);
        },

        switchMpptOff(){
            this.sendCommand(CommandMpptOff);
        },

        startMeasuring(){                        
            this.sendCommand(startMultimetrCommand);
            const deleayBetweenCommands = 500;
            setTimeout(this.switchMode, deleayBetweenCommands);
        },
        stopMeasuring(){                        
            this.sendCommand(stopMultimetrCommand);           
        },        

        prepareCalibrationCommand(lightCoefficient)
        {
            const buffer = new ArrayBuffer(4);
            const farr = new Float32Array(buffer);
            farr[0] = lightCoefficient;
            const uints = new Uint8Array(farr.buffer);

            //yourNumber.toString(16)
            //farr. = lightCoefficient;
            const value = Uint8Array.of(63, ...uints, 65);   
            return value;         
        },

        addArrayValue(array , value)
        {
            if(value == null)
            {
                array = []; 
                return;
            }

            if(array.length > this.avaragingItmesCount)
            {                
                array = [];                
            }
            else if (array.length == this.avaragingItmesCount)
            {
                array.shift();
            }
            
            array.push(value);            
        },

        getAverageAtArray (x)  
        {
            if(x.length == 0)
            {
                return null;
            }
            else{
                return Math.round( 1000 * x.reduce((a,b) => a + b, 0) / x.length) / 1000;
            }
        } ,

    },    
    
}
</script>
